import { render, staticRenderFns } from "./footer-widget.vue?vue&type=template&id=642ddd8f&"
import script from "./footer-widget.vue?vue&type=script&lang=js&"
export * from "./footer-widget.vue?vue&type=script&lang=js&"
import style0 from "./footer-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports